import useCartProducts from './useCartProducts'
import { calculateRewardTotals } from '@/shop/src/utils/shopItemUtils'
import { rewardsProgress } from '@g4g/utils/src/gameDataUtils'
import useRecipientUsers from '../../recipient/hooks/useRecipientUsers'

export default function useRewardsProgress() {
  const { products } = useCartProducts()
  const { progress } = calculateRewardTotals(products)
  const { currentRecipient, loading: loadingRecipient } = useRecipientUsers()

  return {
    progress: rewardsProgress(currentRecipient?.userState, progress.SalePoints, progress.VipExp),
    loading: loadingRecipient,
  }
}
